var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.2029 11.7981L10.7929 13.2081C10.0129 13.9881 10.0129 15.2581 10.7929 16.0381C11.5729 16.8181 12.8429 16.8181 13.6229 16.0381L15.8429 13.8181C16.592 13.0668 17.0127 12.0491 17.0127 10.9881C17.0127 9.92713 16.592 8.90943 15.8429 8.15812C15.0916 7.40897 14.0739 6.98828 13.0129 6.98828C11.9519 6.98828 10.9342 7.40897 10.1829 8.15812L7.76289 10.5781C7.44426 10.8965 7.19149 11.2745 7.01903 11.6906C6.84658 12.1067 6.75781 12.5527 6.75781 13.0031C6.75781 13.4535 6.84658 13.8995 7.01903 14.3156C7.19149 14.7317 7.44426 15.1098 7.76289 15.4281",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachCircle);
export default __webpack_public_path__ + "static/media/attachCircle.5fde7dfd32662f6d6b315dd61a223022.svg";
export { ForwardRef as ReactComponent };